const DEFAULT_PRODUCTION_API_URL = 'https://api.rootify.cloud/api';
const DEFAULT_PRODUCTION_WS_URL = 'wss://api.rootify.cloud';

const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, '');
const trimLeadingSlash = (value: string): string => value.replace(/^\/+/, '');

export const config = {
  /**
   * Produkcni build smeruje na verejne API.
   * Lokalni vyvoj si ponechava vlastni proxy nebo explicitni override z .env.local.
   */
  apiUrl:
    import.meta.env.VITE_API_URL ||
    (import.meta.env.PROD ? DEFAULT_PRODUCTION_API_URL : '/api'),

  wsUrl:
    import.meta.env.VITE_WS_URL ||
    (import.meta.env.PROD ? DEFAULT_PRODUCTION_WS_URL : ''),

  /** ESP32 setup wizard API URL */
  setupApiUrl: import.meta.env.VITE_SETUP_API_URL || 'http://192.168.4.1',

  /** Whether PWA service worker should be registered */
  enablePwa: import.meta.env.VITE_ENABLE_PWA === 'true',

  /** true when running in development mode (Vite dev server) */
  isDev: import.meta.env.DEV,

  /** true when running a production build */
  isProduction: import.meta.env.PROD,
} as const;

export const buildApiUrl = (path: string): string => {
  if (!path) {
    return config.apiUrl;
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  return `${trimTrailingSlash(config.apiUrl)}/${trimLeadingSlash(path)}`;
};
